import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Provides read-only access to application version metadata.
 *
 * All values are injected at build time and bundled into the
 * Angular application. This service exists to centralize
 * access and avoid direct environment imports across the app.
 */
@Injectable({ providedIn: 'root' })
export class AppVersionService {
  /**
   * Semantic application version (from package.json).
   *
   * Example: "1.4.2"
   */
  readonly version = environment.appVersion;

  /**
   * Short Git commit SHA identifying the exact source code
   * used for this build.
   *
   * Example: "3f9c1ab"
   */
  readonly commitShaShort = environment.commitShaShort;

  /** Indicates the build was created with uncommitted changes */
  readonly hasUncommittedChanges = environment.hasUncommittedChanges;

  /**
   * UTC timestamp indicating when the application was built.
   *
   * Example: "2025-12-28T18:42:11.321Z"
   */
  readonly buildTime = environment.buildTime;

  /**
   * Build identifier generated at build time.
   *
   * Uses a CI build ID when available, otherwise a UTC timestamp
   * (YYYYMMDD.HHMM) for local builds.
   *
   * Used for deployment tracking and debugging.
   */
  readonly buildNumber = environment.buildNumber;

  /**
   * Combined, human-readable version string.
   *
   * Example: "v1.0.0+fe.10d80aee-beta" (non-prod)
   * Example: "v1.0.0+fe.10d80aee" (prod)
   */
  get fullVersion(): string {
    return `v${environment.fullVersion}`;
  }
}
